// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"48a85652","113":"2d52299a","187":"ac689644","208":"47449656","232":"431fdd39","278":"dcb9e283","363":"de8b73bc","400":"88eb6c2c","913":"d5ed0781"}[chunkId] + ".chunk.js";
};